/**
 * @desc 箱子和sku解绑
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export type Response = defs.srm.Response;
export function request(boxCode: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/srm/supplierBox/unBindSku/${boxCode}`, {
      method: "POST",

      ...options,
    }),
  );
}
